<script>
export default {
  data () {
    return {
      lazyUpdater: null,
      lazyPersister: null,
    }
  },
  methods: {
    async delayed (method, arg) {
      if (this.lazyUpdater) clearTimeout(this.lazyUpdater)
      this.lazyUpdater = setTimeout(() => method(arg), 500)
    },
    // async delayedPersist (method, arg) {
    //   if (this.lazyPersister) clearTimeout(this.lazyPersister)
    //   this.lazyPersister = setTimeout(() => method(arg), 1000)
    // }

  }
}
</script>
